import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "use-socket.io-client";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import {
  useAppEvenListSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  APPLICATION_GLOBAL_SLUG,
  CRYPTO_SECRET_KEY,
  INSIDERODEO_EVENT_STORAGE,
  paginate,
  PER_PAGE,
  SELECTED_EVENT_STORAGE,
  SOCKET_CHANNEL,
  SOCKET_URL,
  STORAGE,
  URLS,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import clsx from "clsx";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import Sponsor from "src/components/common/Sponsor";
// import Pagination from 'react-js-pagination';

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);
const queryString = require("query-string");

export default function RodeoEventGroupPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const [groups, setGroups] = useState<any>([]);
  const userApi = useUserApi();
  const userAction = useAppUserAction();
  const location = useLocation();

  //Get event List
  const getEventGroupList = () => {
    eventApi.callEventGroupList(
      (message: any, resp: any) => {
        setGroups(resp);
      },
      (message: any) => {}
    );
  };

  const goBack = () => {
    history.goBack();
  };

  const gotoEventPage = (group: any) => {
    localStorage.setItem("group_id", group.id);
    history.push(URLS.HOME);
  };

  useEffect(() => {
    localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);

    const parsedHash = queryString.parse(location.hash);
    console.log("parsedHash", parsedHash);
    if (parsedHash && parsedHash.userToken && parsedHash.userToken != "null") {
      localStorage.setItem("parshedHash", "1");
      userAction.resetGuestUserId();
      localStorage.removeItem("guestUserId");
      localStorage.setItem(STORAGE, parsedHash.userToken);
      userApi.callGetMe(
        (message: string, resp: any) => {},
        (message: string, resp: any) => {
          history.push(URLS.HOME);
          userAction.logout();
        }
      );
    }
    // if (parsedHash && parsedHash.token) {
    //   localStorage.setItem(INSIDERODEO_EVENT_STORAGE, parsedHash.token);
    //   history.push(`/performances/${localStorage.getItem(INSIDERODEO_EVENT_STORAGE)}`);
    // } else if (localStorage.getItem(INSIDERODEO_EVENT_STORAGE)) {
    //   history.push(`/performances/${localStorage.getItem(INSIDERODEO_EVENT_STORAGE)}`);
    // } else {
    // history.push(URLS.HOME);
    // }
  }, []);

  //First Time call When component is load
  useEffect(() => {
    getEventGroupList();
  }, []);

  return (
    <React.Fragment>
      {
        <div className="logo-wrap">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="medium-logo"
            // style={{ marginTop: "10px", marginBottom: "10px", width: "200px" }}
            style={{ marginTop: "50px", marginBottom: "10px", width: "200px" }}
          />
        </div>
      }
      <section className="main-container">
        <h2 className="page-title text-left">
          {/* <a onClick={goBack} className="back-history">
            <img src="/images/left-white.svg" alt="back" />
          </a> */}
          <span>Rodeo </span>Event Groups
        </h2>
        <hr className="color-white" />
        <ul className="list-style rodeo-inside-list">
          {groups?.list?.length ? (
            groups?.list?.map((group: any) => (
              <li key={group.id}>
                <Link
                  to={"/group/" + cryptr.encrypt(group.id)}
                  // onClick={() => gotoEventPage(group)}
                  title={group.title}
                  className="ripple-effect d-flex"
                >
                  <span className="event-img">
                    <img
                      src={group.avatar && group.avatar.thumb ? group.avatar.thumb : "images/no-image.png"}
                      alt={group.title}
                    />
                  </span>
                  <span className="event-info">
                    <span className="d-inline-block event-title">{group.title}</span>
                  </span>
                </Link>
              </li>
            ))
          ) : (
            <div className="no-text text-white text-center">No events available</div>
          )}
        </ul>
        <Sponsor />
      </section>
    </React.Fragment>
  );
}
